import React, { useState, useEffect } from "react";
import { Form } from "@tencent/universe-ui/build/lib";
import OcrTag from './Tag/index.jsx';
import { InputNumber,TagInput, Button,Tooltip, Input, Radio, Select,Dropdown } from 'tdesign-react';
import { splitByCommas, removeLastByType } from '../../utils/index.js'
const { Option } = Select;
const { DropdownMenu, DropdownItem } = Dropdown;
function Params({ rectOptions,clipImg, params, value, onChange, showClose = false, placeholder = "请输入", onClose, onSelect }) {
  const [tags, setTags] = useState([]);
  const [currentKey, setCurrentKey] = useState(null);
  const [defaultTags, setDefaultTags] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [pageSelectType, setPageSelectType] = useState("1");
  const [pageNumber, setPageNumber] = useState(1);
  const [inputPageNumber, setInputPageNumber] = useState(1);
  const [eduValue, setEduValue] = useState(null);


  useEffect(() => {
    if (params?.type == 'inputTag' && value) {
      setTags(value?.map(item => item.KeyName))
      setDefaultTags(params?.default?.map(item => item.KeyName))
    } else if (params?.type == 'pageSelect') {
      if (value) {
        setPageSelectType("2");
        setPageNumber(value)
      } else {
        setPageSelectType("1");
        setPageNumber(0)
      }
    }
  }, [params]);


//  TODO: 默认选中某张图
  useEffect(() => {
    if (clipImg) {
     setEduValue(clipImg?.curRect);
    }else{
      setEduValue(null)
    }
  }, [clipImg,rectOptions]);

  useEffect(() => {
    if (params?.type == 'inputTag' && value) {
      setTags(value?.map(item => item.KeyName))
    } else if (params?.type == 'input-number') {
      setInputPageNumber(value)
    }
  }, [value]);

  useEffect(() => {
    if (params?.type == 'inputTag' && value) {
      setTags(value?.map(item => item.KeyName))
    } else if (params?.type == 'input-number') {
      setInputPageNumber(value)
    }
  }, [value]);

  const tem = () => {
    let paramsCon = <></>;
    switch (params.type) {
      case 'eduAgent':
        paramsCon = <>
          <div className="eduAgent-params-container">
            <span className="eduAgent-params-container__tips">请帮我批改</span>
            <Dropdown 
                hideAfterItemClick  
                placement="bottom-left"
                trigger="hover">
              <Button variant="text" >
                  <div class="eduAgent-params__select">
                    <span style={{
                      color: eduValue?.titleStyle?.activeColor || '#4A70FF',
                      background: eduValue?.titleStyle?.color || '#F1F6FF'
                    }} className="eduAgent-params__optionitem placeholder">
                      {eduValue?.label || '请选择题目'}
                      <div class="eduAgent-params__collops"></div>
                    </span>
                </div>
              </Button>
              <DropdownMenu>
              {
                rectOptions.map((option, idx) => (
                  // <DropdownItem value={211}>操作2-1-1</DropdownItem>
                  <DropdownItem 
                    key={idx} 
                    onClick={() => {
                      setEduValue(option);
                      onSelect && onSelect(option.value, option.value, option);
                    }}
                    >
                    <div style={{ margin: '4px 0' }}>
                      <span style={{
                        color: option.titleStyle.activeColor,
                        background: option.titleStyle.color
                      }} className="eduAgent-params__optionitem">{option.label}</span>
                    </div>
                  </DropdownItem>
                ))
              }
              </DropdownMenu>
            </Dropdown>
            <span className="eduAgent-params-container__tips">，输出答案与计算步骤，以json格式输出。</span>
          </div>
        </>
        break;
      case 'pageSelect':
        paramsCon = <>
          <Form.Item className={`${params.LabelAlign ? 'column' : 'row'}`} label={params.label[0]}>
            <Radio.Group value={pageSelectType} onChange={(e) => {
              setPageSelectType(e)
              if (e == 1) {
                setPageNumber(0);
                onChange && onChange(0);
              } else {
                setPageNumber(1);
                onChange && onChange(1);
              }
            }}>
              <Radio key={1} value="1">全部抽取</Radio>
              <Radio key={2} value="2">单页抽取</Radio>
            </Radio.Group>
          </Form.Item>
          {
            pageSelectType == 2 && <Form.Item label={params.label[1]} className={`${params.LabelAlign ? 'column' : 'row'}`}>
              <InputNumber
                value={pageNumber}
                min={params.min}
                max={params.max}
                step={1}
                onStep={(value) => {
                  onChange && onChange(value);
                }}
                onChange={(value) => {
                  onChange && onChange(value);
                }} />
            </Form.Item>
          }

        </>
        break;
      case 'inputTag':
        paramsCon = <>
          {
            params.labelList?.map(label => {
              return <Form.Item
                className={`${params.LabelAlign ? 'column' : 'row'}`}
                label={
                  <div style={{display: 'flex',alignItems:'center'}}>
                    <span>{label.label}</span>
                    {label.des &&
                      <Tooltip content={label.des} theme="light">
                        <span className="ocrDemo-icon-question"></span>
                      </Tooltip>
                    }
                  </div>
                }>
                <TagInput
                  value={tags}
                  disabled={showConfirm}  //  当需要输入抬头提示词时开启，否则无法聚焦
                  placeholder="输入字段名，多个字段用逗号分隔"
                  excessTagsDisplayType="break-line"
                  size="medium"
                  onChange={(e, cur) => {
                    if (cur.e.keyCode === 8 || cur.e.keyCode === 46) {
                      // 按了删除键
                      let _val = removeLastByType(value, label.KeyType, 'KeyType')
                      onChange(_val)
                    } else {
                      if (!e.length) return
                      let _curVal = splitByCommas(cur.item)
                      let _val = value;
                      _curVal.map(i => {
                        _val.push({
                          KeyName: i,
                          KeyType: label.KeyType,
                          KeyPrompt: ''
                        })
                      })
                      onChange(_val);
                    }

                  }}
                  onClear={(e) => {
                    let _val = value.filter(i => i.KeyType !== label.KeyType)
                    onChange(_val);
                  }}
                  valueDisplay={({ value: tags }) =>
                    tags?.map((item, index) => {
                      if (value[index]?.KeyType !== label.KeyType) {
                        return <></>
                      }
                      else {
                        return <OcrTag
                          keyVal={index}
                          currentKey={currentKey}
                          maxPrompt={params.KeyPromptMax}
                          keyPrompt={value[index]?.KeyPrompt}
                          onConfirm={
                            (val) => {
                              let _val = value;
                              _val[index].KeyPrompt = val.KeyPrompt;
                              onChange(_val);
                            }
                          }
                          onChoose={(e) => {
                            setCurrentKey(e)
                          }}
                          setShowConfirm={
                            (val) => {
                              setShowConfirm(val)
                              if (!val) {
                                setCurrentKey(null)
                              }
                            }
                          }
                          content={item}
                          theme={defaultTags.includes(item) ? 'star' : 'primary'}
                          onClose={(val, key) => {
                            value.splice(index, 1);
                            onChange(value)
                          }} />
                      }
                    })
                  }
                  clearable
                />
              </Form.Item>
            })
          }
        </>

        break;
      case 'switch':
        paramsCon = <Form.Item
          className={`${params.LabelAlign ? 'column' : 'row'}`}
          label={
            <>
              <span>{params.label}</span>
              {params.des &&
                <Tooltip content={params.des} theme="light">
                  <span className="ocrDemo-icon-question"></span>
                </Tooltip>
              }
            </>
          }>
          <Radio.Group value={value ? '1' : '2'} onChange={(value) => {
            let finialVal = value === '1' ? true : false
            onChange && onChange(finialVal);
          }} className="unv-radio__group unv-radio__group--grid unv-radio__group--grid-3">
            {
              params.options.map((op, index) => (
                <Radio key={index} value={op.value ? '1' : '2'}>{op.text}</Radio>
              ))
            }
          </Radio.Group>
        </Form.Item>
        break;
      case 'select':
        paramsCon = <Form.Item
          className={`${params.LabelAlign ? 'column' : 'row'}`}
          label={
            <>
              <span>{params.label}</span>
              {params.des &&
                <Tooltip content={params.des} theme="light">
                  <span className="ocrDemo-icon-question"></span>
                </Tooltip>
              }
            </>
          }>
          <div className="flex">
            <div style={{ maxWidth: '100%' }}>
              <Select
                status={params.status}
                options={params.options}
                keys={{
                  value: 'value',
                  label: 'text'
                }}
                placeholder='请选择'
                value={value}
                onChange={(value) => {
                  const extra = params.options[params.options.findIndex(i => i.value === value)];
                  let realVal = extra?.realValue || value;
                  onChange && onChange(value, realVal, extra);
                }}
              />
            </div>
            {
              showClose && <i className="universe-icon univ-icon-close ml-10" onClick={onClose}></i>
            }
          </div>
        </Form.Item>
        break;
      case 'mulSelect':
        paramsCon = <Form.Item
          className={`${params.LabelAlign ? 'column' : 'row'}`}
          label={
            <>
              <span>{params.label}</span>
              {params.des &&
                <Tooltip content={params.des} theme="light">
                  <span className="ocrDemo-icon-question"></span>
                </Tooltip>
              }
            </>
          }>
          <div className="flex">
            <div tyle={{ maxWidth: '100%' }}>
              <Select
                options={params.options}
                keys={{
                  value: 'value',
                  label: 'text'
                }}
                placeholder='请选择'
                value={typeof value === 'array' ? '' : value?.join('')}
                onChange={(value) => {
                  onChange && onChange(value ? [Number(value)] : []);
                }}
              />
            </div>

            {
              showClose && <i className="universe-icon univ-icon-close ml-10" onClick={onClose}></i>
            }
          </div>
        </Form.Item>
        break;
      case 'radio':
        paramsCon = <Form.Item
          className={`${params.LabelAlign ? 'column' : 'row'}`}
          label={
            <>
              <span>{params.label}</span>
              {params.des &&
                <Tooltip content={params.des} theme="light">
                  <span className="ocrDemo-icon-question"></span>
                </Tooltip>
              }
            </>
          }>
          <Radio.Group value={value} onChange={(e) => {
            const extra = params.options[params.options.findIndex(i => i.value === e)];
            onChange && onChange(e, e, extra);
          }} className="unv-radio__group unv-radio__group--grid unv-radio__group--grid-3">
            {
              params.options.map((op, index) => (
                <Radio key={index} value={op.value}>{op.text}</Radio>
              ))
            }
          </Radio.Group>
        </Form.Item>
        break;
      case 'input':
        paramsCon = <Form.Item
          className={`${params.LabelAlign ? 'column' : 'row'}`}
          label={
            <>
              <span>{params.label}</span>
              {params.des &&
                <Tooltip content={params.des} theme="light">
                  <span className="ocrDemo-icon-question"></span>
                </Tooltip>
              }
            </>
          }>
          <div className="flex">
            <Input
              status={params.status}
              value={value} onChange={(e) => {
                onChange && onChange(e);
              }}
              placeholder={placeholder} />
            {
              showClose && <i className="universe-icon univ-icon-close ml-10" onClick={onClose}></i>
            }
          </div>
        </Form.Item>
        break;
      case 'input-number':
        paramsCon = <Form.Item
          className={`${params.LabelAlign ? 'column' : 'row'}`}
          label={
            <>
              <span>{params.label}</span>
              {params.des &&
                <Tooltip content={params.des} theme="light">
                  <span className="ocrDemo-icon-question"></span>
                </Tooltip>
              }
            </>
          }>
          <div className="flex">
            <InputNumber
              value={inputPageNumber}
              step={1}
              min={params.min}
              max={params.max}
              onChange={(value) => {
                if (value == undefined) {
                  onChange && onChange(params.min);
                } else if (value > params.max) {
                  onChange && onChange(params.max);
                } else if (value < params.min) {
                  onChange && onChange(params.min);
                } else {
                  onChange && onChange(value);
                }
              }} />
          </div>
        </Form.Item>
        break;
    }
    return paramsCon
  }
  return (
    <>
      {tem(params)}
    </>
  );
}

export default Params;
